<template>
  <el-card>
    <div class="dayquery flex-n" style="width: 100%">

      <div class="left-content">
        <div class="flex-n fac month-tab">
          <div class="flex-1" @click="$emit('beforeMonth')">上个月</div>
          <div class="flex-1" @click="$emit('nowMonth')">本月</div>
          <div class="flex-1" @click="$emit('afterMonth')">下个月</div>
        </div>
        <div class="left-top-content">
          <div :class="index>4?'weekend':''" v-for="(item,index) in labelTitle" :key="index">{{item}}
          </div>
        </div>
        <div class="left-grid-content"
             :style="{'grid-template-rows':'repeat('+(orderTotalList.length/7)+', minmax(100px, 1fr))'}">
          <div :class="[month==item.month?'':'not',beginDate==item.orderDate?'choose':'']"
               v-for="(item,index) in orderTotalList" :key="index" @click="$emit('chooseDate',item.orderDate)">
            <div class="flex-n fjb" style="height: 20px"
                 :style="{color:item.orderDate==$TM.getDate((new Date()).getTime())?'#c83838':'',fontWeight:item.orderDate==$TM.getDate((new Date()).getTime())?'bolder':''}">
              <div class="day">{{item.day}}
                <div class="el-icon-star-on" v-if="item.isImportant"></div>
              </div>

              <div class="solarlunar textnowrap">{{item.solarlunar}}</div>
            </div>
            <div style="height: calc(100% - 20px);">
              <template v-for="(itm,index) in item.houseOrderCalc">
                <div class="flex-n fac fjb flex-1" v-if="itm.houseTypeCode=='01'">
                  <img class="icon" :src="require('../../../common/images/c1.png')"/>
                  <div class="num">{{itm.orderCount}}</div>
                </div>
                <div class="flex-n fac fjb flex-1" v-if="itm.houseTypeCode=='03'">
                  <img class="icon" :src="require('../../../common/images/c3.png')"/>
                  <div class="num oneline">{{itm.orderCount}}</div>
                </div>
                <div class="flex-n fac fjb flex-1" v-if="itm.houseTypeCode=='02'">
                  <img class="icon" :src="require('../../../common/images/c2.png')"/>
                  <div class="num oneline">{{itm.orderCount}}</div>
                </div>
              </template>
              <div class="flex-n fac fjb flex-1" v-if="isDisplayPrein=='1'">
                <img class="icon" :src="require('../../../common/images/c4.png')"/>
                <div class="num oneline">{{item.totalMoney}}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <synchronous-scrolling class="right-content flex-1 ml-20"
                             :template-columns="'repeat('+cartlist.length+',minmax(120px,1fr))'"
                             :columns="cartlist.length" :num="gridNum">
        <template slot="left">
          <div v-for="(item,index) in timeList" :key="index">{{item.indexOf('30')>-1?'':item}}</div>
        </template>
        <template slot="top">
          <div v-for="(item,index) in cartlist" :key="index" v-pointer
               @click="addReserve(item.id,item.houseTypeCode,beginDate)">{{item.houseName}}
          </div>
        </template>
        <div class="info-box" :class="'order'+item.orderState"
             :style="{'grid-row': item.rowStart+'/'+item.rowEnd,'grid-column': item.columnStart+'/'+ item.columnEnd}"
             v-for="(item,index) in dayDataList" :key="index" v-pointer @click="editReserve(item)">
          <div class="title-area flex-n fac fjb" style="width: 100%">
            <div class="flex-n fac"  style="width: calc(100% - 20px)">
              <div class="font-xi" :class="item.hasWedding=='0'?'':'font-xi-success'" v-if="item.isWedding==1"
                   @click.stop="changeWedding(item.id, item.weddingId, item.hasWedding) "></div>
              <div class="title oneline">{{item.hasWedding=='1'?(item.femaleName+'、'+item.maleName):item.customName}}
              </div>
            </div>
            <i class="copy el-icon-document-copy"
               @click.stop="copyInfo(item.id)"></i>
          </div>
          <div class="content" v-if="item.rowEnd-item.rowStart">
            <div class="flex-n fac">
              <i class=" el-icon-time"></i>
              <div style="margin-left: 5px">
                {{item.labelText}}
              </div>
            </div>
            <template v-if="item.rowEnd-item.rowStart>1">
              <div class="flex-n fac">
                <i class=" el-icon-date"></i>
                <div style="margin-left: 5px">{{item.packageName}}[{{item.ordertype}}]</div>
              </div>
              <div class="flex-n fac" v-if="item.rowEnd-item.rowStart>2">
                <i class=" el-icon-user"></i>
                <div style="margin-left: 5px">{{item.createUserName}}</div>
              </div>
              <div class="flex-n fac" v-if="(item.rowEnd-item.rowStart>3)&&item.remark">
                <i class=" el-icon-notebook-2"></i>
                <div style="margin-left: 5px">{{item.remark}}</div>
              </div>
            </template>
          </div>
        </div>
      </synchronous-scrolling>
    </div>

    <!--预定-->
    <books :id="id" ref="books" :visible.sync="booksDialog" @refresh="refresh"></books>
    <!--查看预订-->
    <view-book :id="id" :visible.sync="lookOrder"></view-book>
    <!--编辑婚庆-->
    <edit-wedding :id="id" :wed-id="wedId" :visible.sync="showWeddingDialog" :type="wedState"
                  @refresh="refresh"></edit-wedding>
  </el-card>
</template>

<script>
  import solarlunar from '@/common/js/solarlunar.js';
  import SynchronousScrolling from "../../../components/SynchronousScrolling";
  import Books from "../../component/books";
  import ViewBook from "./ViewBook";
  import EditWedding from "./EditWedding";

  export default {
    components: {
      EditWedding,
      ViewBook,
      Books,
      SynchronousScrolling
    },
    name: "day-query",
    data() {
      return {
        cartlist: [],
        labelTitle: ['一', '二', '三', '四', '五', '六', '日'],
        month: 0,
        orderTotalList: [],
        beginDate: '',
        startTime: '7:30',
        endTime: '31:00',
        timeList: [],

        gridNum: 0,
        today: '',
        dayDataList: [],//日数据列表
        houseTypeIds: [],//选中的场地类型列表

        id: '',//订单id
        booksDialog: false, //预订弹窗

        lookOrder: false, //查看预订

        wedState: 0, //婚庆数据状态
        showWeddingDialog: false, //婚庆弹窗
        wedId: '',
        isDisplayPrein: '1',
        timeTagList: [],
        tagList: []
      }
    },
    watch: {},
    methods: {
      //todo 获取场地
      gethouseList(checkedList) {
        console.log('选中的场地类型', checkedList)
        this.houseTypeIds = checkedList;
        this.$axios.get("/house/houseListByStoreId/" + this.$root.getStorage('storeId')).then(res => {
          console.log('场地', res.data.list)
          var list = res.data.list;
          let cartlist = [];
          if (checkedList.length == 0) {
            this.cartlist = list;
          } else {
            for (var j = 0; j < list.length; j++) {
              if (checkedList.indexOf(list[j].houseTypeId) > -1) {
                cartlist.push(list[j])
              }
            }
            this.cartlist = cartlist;
            console.log('该类型的场地有', cartlist)
          }
          this.getTimeRange();
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      getTimeRange() {
        this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
          console.log('基本店铺设置信息', res.data)
          let timeRange = res.data.timeRange.split('-')
          this.startTime = timeRange[0] || '00:00';
          this.endTime = timeRange[1] || '24:00';
          let orderTag = [];
          for (let i in res.data.orderTag) {
            orderTag.push(res.data.orderTag[i].beginTime + '~' + res.data.orderTag[i].endTime)
          }
          this.timeTagList = orderTag;
          this.tagList = res.data.orderTag;
          this.getTimeList();
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      getTimeList() {
        let startTime = Number(this.startTime.replace(':', ''));
        let endTime = Number(this.endTime.replace(':', ''));
        let timeList = [];
        if (startTime % 100) {
          timeList.push((Number(startTime / 100).toFixed(0) > 10 ? Number(startTime / 100).toFixed(0) : ('0' + Number(startTime / 100).toFixed(0))) + ':30');
          startTime += 70;
        }

        console.log(startTime)
        for (let i = startTime; i < endTime; i = i % 100 == 30 ? (i + 70) : (i + 30)) {

          timeList.push(this.getFormatTimeText(String(i)));
        }

        this.timeList = timeList;
        this.gridNum = (timeList.length || 0) * (this.cartlist.length || 0);
        this.getDayOrders();
      },
      getCalendar(beginDate, houseTypeIds) {
        // var houseTypeIds  = uni.getStorageSync('searchField')||[];
        console.log(beginDate, houseTypeIds)
        let year, month;
        this.beginDate = beginDate;
        this.houseTypeIds = houseTypeIds;
        if (beginDate) {
          month = Number(beginDate.substring(5, 7));
          this.month = month;
          year = Number(beginDate.substring(0, 4));
        }
        let startTime = this.$TM.getDate(new Date(year + '-' + month + '-1').getTime() - (new Date(year + '-' + month + '-1').getDay() - 1) * 24 * 60 * 60 * 1000);

        let endTime = '';
        if (month + 1 == 13) {
          endTime = this.$TM.getDate(new Date((year + 1) + '-1-1').getTime() + (7 - new Date((year + 1) + '-1-1').getDay()) * 24 * 60 * 60 * 1000);
        } else {
          endTime = this.$TM.getDate(new Date(year + '-' + (month + 1) + '-1').getTime() + (7 - new Date(year + '-' + (month + 1) + '-1').getDay()) * 24 * 60 * 60 * 1000);
        }
        console.warn(startTime, endTime,houseTypeIds)
        this.$axios.post("/order/orderCalendarTotalCalc", {
          "startTime": startTime,
          "endTime": endTime,
          "storeId": this.$root.getStorage('storeId'),
          "houseTypeIds": houseTypeIds,
        }).then(res => {
          console.log('数量统计', res)
          let list = res.data.list;
          for (var i in list) {
            let orderDate = list[i].orderDate;
            list[i].solarlunar = solarlunar.solar2lunar(orderDate.substring(0, 4), orderDate.substring(5, 7), orderDate.substring(8)).IDayCn;
            list[i].day = orderDate.substring(8);
            list[i].month = orderDate.substring(5, 7);
          }
          this.orderTotalList = res.data.list;
          this.gethouseList(houseTypeIds);
        }).catch(err => {
          this.$refs.message.error(err.msg)
        })
      },
      //todo 刷新列表 ，新建在哪天 刷新到哪天
      refresh(orderDate) {
        console.log('刷新的天', orderDate)
        this.$emit('chooseDate', orderDate);
      },
      //todo 新增预订
      addReserve(houseId, houseTypeCode, date) {
        this.id = '';
        if (houseId) {
          this.$refs.books.dataForm.houseId = houseId;
          this.$refs.books.dataForm.houseTypeCode = houseTypeCode;
        }
        if (date) {
          this.$refs.books.dataForm.orderDate = date;
        }
        this.booksDialog = true;
      },
      //todo 编辑预定
      editReserve(data) {
        this.id = data.id;
        if (data.confirmState != '01' && ((this.$root.getStorage('menuAuth').isEditOther == 0 && (this.$root.getStorage('info').userId == data.createUserCode)) || this.$root.getStorage('menuAuth').isEditOther == 1)) {
          this.booksDialog = true;
        } else {
          return this.lookOrder = true;
        }
      },
      //日订单数据列表
      getDayOrders() {
        // this.loading = true;
        this.$axios.post('/order/orderCalendarDayOrders', {
          "orderDate": this.beginDate,
          "houseTypeIds": this.houseTypeIds,
          "storeId": this.$root.getStorage('storeId')
        }).then(res => {
          console.log('日订单数据列表', res)
          // this.loading = false;
          var dayDataList = res.data.list;
          for (var i in dayDataList) {
            let columnStart = this.cartlist.findIndex((item) => {
              return item.id == dayDataList[i].houseId
            }) + 1;
            dayDataList[i].activityBeginTime = dayDataList[i].activityBeginTime.length == 5 ? dayDataList[i].activityBeginTime : ('0' + dayDataList[i].activityBeginTime)
            dayDataList[i].activityEndTime = dayDataList[i].activityEndTime.length == 5 ? dayDataList[i].activityEndTime : ('0' + dayDataList[i].activityEndTime)

            dayDataList[i].columnStart = columnStart;
            dayDataList[i].columnEnd = columnStart + 1;

            let startTime = this.getFormatTimeText(dayDataList[i].activityBeginTime);
            let endTime = this.getFormatTimeText(dayDataList[i].activityEndTime);
            let item = dayDataList[i];

            let idx = this.timeTagList.indexOf(item.activityBeginTime + '~' + item.activityEndTime);

            let labelText = idx > -1 ? this.tagList[idx].tagName : (startTime+'~'+endTime);
            dayDataList[i].labelText = labelText;
            // {{item.activityBeginTime==item.activityBeginTimeReal?item.activityBeginTime:('次日'+item.activityBeginTimeReal)}}~{{item.activityEndTime==item.activityEndTimeReal?item.activityEndTime:('次日'+item.activityEndTimeReal)}}

            console.log(startTime, endTime, this.timeList);
            let rowStart = this.timeList.findIndex((item) => {
              return item == startTime
            });
            let rowEnd = this.timeList.findIndex((item) => {
              return item == endTime
            });
            console.log(rowStart, rowEnd)
            if (rowStart == -1 && rowEnd != -1) {
              dayDataList[i].rowStart = 1
            } else {
              dayDataList[i].rowStart = rowStart + 1;
            }
            if (rowEnd == -1 && rowStart != -1) {
              dayDataList[i].rowEnd = this.timeList.length + 1;
            } else {
              dayDataList[i].rowEnd = rowEnd + 1;
            }
            // if(rowEnd==-1&&rowStart==-1){
            //   dayDataList.splice(i,1);
            //   break;
            // }
            // console.warn(dayDataList[i].rowStart, dayDataList[i].rowEnd)
            var ordertype = '', content = '';
            for (var l in dayDataList[i].payTypes) {
              if (dayDataList[i].payTypes[l].payTypeCode == '01') {
                if (dayDataList[i].payTypes[l].orderCount)
                  content += dayDataList[i].payTypes[l].orderCount + '人、';
              }
              if (dayDataList[i].payTypes[l].payTypeCode == '02') {
                if (dayDataList[i].payTypes[l].orderCount)
                  content += dayDataList[i].payTypes[l].orderCount + '桌、';
              }
            }
            if (content.length > 0)
              content = content.substring(0, content.length - 1)
            if (dayDataList[i].mainPayType == '03') {
              if (content.length > 0)
                ordertype = '包场(' + content + ')';
              else {
                ordertype = '包场';
              }
            } else {
              ordertype = content;
            }
            dayDataList[i].ordertype = ordertype;
          }
          this.dayDataList = dayDataList;
          console.log(dayDataList)
          this.getAuthState();
        }).catch(err => {
          this.$message.error(err.msg);
          this.loading = false;
        })
      },
      getAuthState() {
        this.$axios.post("storeAuth/findByRoleIdStoreId", {
          "roleId": this.$root.getStorage('info').roleId,
          "storeId": this.$root.getStorage('storeId')
        }).then(res => {
          console.log(res.data)
          //不可编辑
          this.isDisplayPrein = res.data.auth.isDisplayPrein;

        }).catch(err => {
          this.$refs.message.error(err.msg);
        })
      },
      getFormatTimeText(time) {
        let ytime = Number(time.replace(':', ''));
        var c1 = Number(ytime / 100).toFixed(0)
        c1 = c1 < 10 ? ('0' + c1) : (c1 > 23 ? ('次日' + ((c1 - 24) > 9 ? (c1 - 24) : ('0' + (c1 - 24)))) : c1);
        c1 = c1 + ':' + (ytime % 100 ? '30' : '00')
        return c1;
      },
      changeWedding(id, wedid, data) {
        this.id = id;
        this.wedId = wedid;
        this.showWeddingDialog = true;
        this.wedState = data;
      },
      copyInfo(id) {
        this.$emit('copyInfo', id);
      }
    }
  }
</script>

<style scoped lang="scss">
  .dayquery {
    height: calc(100vh - 250px);
    position: relative;
    .left-content {
      width: 400px;
      min-width: 400px;
      height: calc(100vh - 250px);
      border: 1px solid #f1f1f1;
      .month-tab {
        height: 30px;
        user-select: none;
        > div {
          border: 1px solid #ddd;
          text-align: center;
          height: 20px;
          line-height: 20px;
          padding: 5px 0;
          cursor: pointer;
          &:hover {
            color: white;
            background: #3b87e4;
          }
        }
      }
      .left-top-content {
        display: grid;
        background: white;
        grid-gap: 1px;
        grid-template-columns: repeat(7, 1fr);
        line-height: 40px;
        //border-top: 1px solid #ddd;
        > div {
          text-align: center;
        }
        .weekend {
          color: #f6ac45;
        }
      }
      .left-grid-content {
        overflow-y: scroll;
        height: calc(100vh - 322px);
        &::-webkit-scrollbar {
          display: none;
        }
        display: grid;
        grid-gap: 1px;
        border-top: 1px solid #f1f1f1;
        background: #ddd;
        grid-template-columns: repeat(7, 1fr);

        > div {
          cursor: pointer;
          background: white;
          padding: 5px;
          overflow: hidden;
        }
        .choose {
          background: #ffe0a4;
          //color: #c83838;
        }
        .not {
          background: #f7f7f7;
          .day {
            color: #999999;
          }
          .solarlunar {
            color: #999999;
          }
        }
        .day {
          font-size: 12px;
          position: relative;
          .el-icon-star-on {
            position: absolute;
            right: -10px;
            top: -4px;
            transform: scale(0.7);
            color: #dd6161;
          }
        }
        .solarlunar {
          font-size: 12px;
        }
        .icon {
          width: 10px;
          height: 10px;
          border-radius: 7px;
        }
        .num {
          color: #333333;
          font-size: 12px;
        }
      }
    }
    .right-content {
      border: 1px solid #f1f1f1;
      /*overflow: scroll;*/
      width: calc(100% - 420px);

    }
  }

  .info-box {
    margin: 2px;
    border-radius: 4px;
    /*background: #e6e6e6;*/
    background: white;
    /*box-shadow: 0 0 10px 1px #eeeeee;*/
    height: calc(100% - 7px) !important;
    z-index: 100;
    align-items: flex-start !important;
    width: calc(100% - 7px);
    overflow: hidden;
    position: relative;
    display: block !important;
    .copy{
      position: absolute;
      right: 4px;
    }
    &:hover {
      box-shadow: 0 0 10px 1px #eeeeee;
    }
    .title-area {
      color: #333333;
      font-weight: bold;
      /*background: #e6e6e6;*/
      padding: 0 5px;
      line-height: 20px;
      /*border-bottom: 1px solid #eeeeee;*/
      .title {
        font-size: 14px;
      }
      .phone {
        margin: 0 5px;
      }
      .font-xi {
        width: 14px;
        height: 14px;
        min-width: 14px;
        margin-right: 10px;
        border: 1px solid #666666;
        background: #eeeeee;
        transform: rotate(45deg);
        transform-origin: center center;
        position: relative;
        font-weight: lighter;
        &::before {
          display: block;
          content: '喜';
          position: absolute;
          left: 1px;
          top: -4px;
          font-size: 12px;
          transform: rotate(-45deg);
        }
      }
      .font-xi-success {
        border: 1px solid #ff3918;
        background: #eed4d5;
        color: #ff3918;
      }
      .el-icon-document-copy {
        cursor: pointer;
      }
    }
    .content {
      padding: 0 5px;
      line-height: 24px !important;
    }
    &.order01 {
      background: #D8C9FC;
      border: 1px solid #dabdee !important;
    }
    &.order02 {
      background: #D0E5FF;
      border: 1px solid #bdd0ee !important;
    }
    &.order03 {
      background: #e6e6e6;
      border: 1px solid #e6e6e6 !important;
    }
  }
</style>
